import React from 'react';
import G from "../../libs/Glob.mjs";
import TextLabel from "../../controls/TextLabel.mjs";
import {Form, Input, InputGroup, InputGroupText, Label} from "reactstrap";
import appLib from "../../libs/appLib.mjs";
import MultiLangLabelField from "../fields/MultiLangLabelField.mjs";
import IntervalTypeField from "../fields/IntervalTypeField.mjs";
import RemediationField from "../fields/RemediationField.mjs";
import TagsEditor from "../fields/TagsEditor.mjs";
import TagsIcon from "../../media/images/TagsIcon.mjs";

const prefix = 'FormLibraryNodeEditor';

const FormLibraryNodeEditor = class extends React.Component {
	constructor(props) {
		super(props);
		const d = props?.data ?? {};
		this.state = { data: { weight: 1 } };
		Object.entries( d ).forEach(([key, value]) => {
			this.state.data[key] = value;
		});
		this.uid = G.generateUid(prefix);
		this.setData = this.setData.bind(this);
		this.setValid = this.setValid.bind(this);
		this.setValue = this.setValue.bind(this);
	}
	componentDidMount() {
		appLib.listLibraries().then( (libraries) => {
			this.setState({libraries: libraries});
		});
		this.setValid();
	}
	setData(d) {
		this.setState( { data: d }, ()=>{
			if ( typeof this.props.setData === 'function') this.props.setData(d);
			this.setValid();
		} );
	}
	setValid() {
		if ( typeof this.props.setValid === 'function') {
			setTimeout( ()=>{
				this.props.setValid(! window.document.querySelector(`#${this.uid} .is-invalid`));
			}, 500);
		}
	}
	/**
	 * @param {Event|HTMLFormElement|string} field
	 * @param {string|number|boolean|null} [value]
	 * @return {void}
	 */
	setValue = (field, value ) => {
		if ( field?.target ) field = field.target;
		if ( field?.name ) {
			value = field.value;
			field = field.name;
		}
		const data = this.state.data;
		if ( ! value || ( typeof value === 'string' && ! value.trim() ) ) {
			delete data[field];
		} else {
			data[field] = value;
		}
		this.setData( data );
	}
	render() {
		if ( ! this.state.libraries ) return '';
		return(
			<Form
				id={this.uid}
				className={'library-editor '+prefix}
				autoComplete="off"
				onSubmit={ (evt) => {
					evt.preventDefault();
				}}
			>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Code"} />
						</Label>
					</InputGroupText>
					<Input
						name={"code"}
						value={ this.state.data.code || '' }
						onChange={ e => {
							this.setValue('code', e.target.value.replace(/[^a-z0-9./-]+/gi,'_'));
						} }
						valid={ !! this.state.data.code }
						invalid={ ! this.state.data.code  }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Visible code"} />
						</Label>
					</InputGroupText>
					<Input
						name={"viewcode"}
						value={ this.state.data.viewcode || '' }
						placeholder={ G.label('ViewcodePlaceholder') }
						onChange={ e => {
							this.setValue('viewcode', e.target.value.replace(/[^a-z0-9./-]+/gi,'_'));
						} }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Name"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.name }
							langs={ this.props.languages }
							onChange={ n => { this.setValue( 'name', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Description"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.description }
							langs={ this.props.languages }
							long={true}
							onChange={ n => { this.setValue( 'description', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Asset"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.asset }
							langs={ this.props.languages }
							long={true}
							onChange={ n => { this.setValue( 'asset', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TagsIcon />
						</Label>
					</InputGroupText>
					<TagsEditor
						value={ this.state.data.tags || [] }
						onChange={ n => { this.setValue( 'tags', n ) }}
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Note"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<MultiLangLabelField
							value={ this.state.data.note }
							langs={ this.props.languages }
							long={true}
							onChange={ n => { this.setValue( 'note', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Remediation"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<RemediationField
							value={ this.state.data?.remediation || {} }
							langs={ this.props.languages }
							onChange={ n => { this.setValue( 'remediation', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Weight"} />
						</Label>
					</InputGroupText>
					<Input
						type={"number"}
						name={"weight"}
						value={ (Math.round( (this.state.data.weight||1) * 100) /100).toFixed( 2) }
						onChange={ e => {
							const v = parseFloat(e.target.value || '1');
							this.setValue('weight', (Math.round( v * 100) /100) );
						} }
					/>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Mandatory"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"clear"}>
						<IntervalTypeField
							values={ appLib.mandatoryValues() }
							value={ this.state.data.mandatory }
							onChange={ n => { this.setValue( 'mandatory', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Coverage"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							value={this.state.data.coverageMax}
							onChange={ n => { this.setValue( 'coverageMax', n ) }}
						/>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							values={ appLib.aggregationValues() }
							value={this.state.data.coverageAggr}
							onChange={ n => { this.setValue( 'coverageAggr', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
				<InputGroup>
					<InputGroupText>
						<Label>
							<TextLabel value={"Maturity"} />
						</Label>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							value={this.state.data.maturityMax}
							onChange={ n => { this.setValue( 'maturityMax', n ) }}
						/>
					</InputGroupText>
					<InputGroupText className={"flex-grow-1 clear"}>
						<IntervalTypeField
							values={ appLib.aggregationValues() }
							value={this.state.data.maturityAggr}
							onChange={ n => { this.setValue( 'maturityAggr', n ) }}
						/>
					</InputGroupText>
				</InputGroup>
			</Form>
		);
	}
}

export default FormLibraryNodeEditor;